import script from "./groups-audit-log.vue?vue&type=script&setup=true&lang=js"
export * from "./groups-audit-log.vue?vue&type=script&setup=true&lang=js"

import "./groups-audit-log.vue?vue&type=style&index=0&id=17814923&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17814923"]])

export default __exports__